module.exports = __webpack_public_path__ + "img/history1.9e2eeac7.jpeg";